var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags-container"},_vm._l((_vm.tags),function(tag){return _c('div',{key:tag.no,staticClass:"tag"},[_c('span',[_vm._v(_vm._s(tag.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }